import controller from './purchase-record.controller'
import template   from './purchase-record.html'
import './purchase-record.styl'

let component = {
  restrict: 'E',
  bindings: {
    record: '<'
  },
  controller,
  template
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/components/purchase-record/purchase-record.component.js